<template>
  <v-container max-width="1200">
    <v-btn
      v-show="!isVisible"
      class="position-fixed top-0 right-0 ma-4"
      color="primary"
      elevation="4"
      icon="mdi-arrow-collapse"
      size="small"
      @click="exit_fullscreen"
      style="z-index: 10000"
    ></v-btn>

    <v-card class="pa-1 pa-md-2 align-center justify-center">
      <v-card-text class="pa-1 pa-md-2">
        <div v-show="!initial_loaded">
          <v-row align="center" class="">
            <v-col cols="12" class="d-flex align-center justify-center py-8">
              <v-progress-circular
                indeterminate
                color="primary"
                class="mr-6"
              ></v-progress-circular>
              <div class="text-subtitle-2 text-grey">Loading Aurora Data...</div>
            </v-col>
          </v-row>
        </div>
        <div v-show="(filtered_images.length != 0 && filtered_images[currentIndex].video == '') || showImage || load_error">
          <Splide :options="
            { 
              arrows: false, 
              rewind: true, 
              pagination: 
              false, 
              type: 'fade', 
              speed: 0,
              autoHeight: true, 
            }" 
            aria-label="Vue Splide Example" ref="main" class="main">
            <SplideSlide v-for="image in filtered_images" v-bind:key="image.id" style="justify-content: center;display: flex;">
              <img 
                :src="'https://aurorafinder.app/api/aurora_image/' + image.image_name" 
                onerror="this.onerror=null;this.src='https://placehold.co/968x563/000000/FFF?text=No+Image/Video+Available';" 
                alt="No Image">
            </SplideSlide>
          </Splide>
        </div>

        <div v-show="showVideo && !showImage && !load_error" id="wrapper">
          
          <vue-plyr ref="plyr" 
          :options="    
            {
              fullscreen: { enabled: isMobileSafari ? false : true }
            }
          ">
            <div class="plyr__video-embed">
              <iframe id="iframe"
                :src="src"
                allowtransparency
                allow="autoplay"
              ></iframe>
              <div v-if="this.currentLive" class="text"><h1>LIVE</h1></div>
            </div>
          </vue-plyr>
        </div>
        <v-row v-if="$vuetify.display.mobile && filtered_images.length > 0" align="center" class="mx-0 mt-2">
            <v-col cols="12" class="d-flex align-center pl-2">
              <!-- <p>ID: {{ filtered_images[currentIndex].id }}</p>
              <p>Name: {{ filtered_images[currentIndex].image_name }}</p> -->
              <div>{{ convertTime(filtered_images[currentIndex].timestamp) }} - Tier: {{ convertTier(filtered_images[currentIndex].tier) }}</div>
              <!-- <p>Live: {{ currentLive }}</p> -->
              <!-- <p>Test Timestamp: {{ filtered_images[currentIndex].timestamp }}</p>
              <p>Test Live: {{ filtered_images[currentIndex].live }}</p>
              <p>Test Video ID: {{ filtered_images[currentIndex].video }}</p> -->
            <v-spacer></v-spacer>
            <v-btn 
              v-show="isMobileSafari && !load_error" 
              @click="fullscreen"
              color="primary"
              elevation="4"
              icon="mdi-arrow-expand"
              size="x-small"
            ></v-btn>
          </v-col>
        </v-row>


        <Splide v-show="filtered_images.length !== 0" class="mt-4 thumbnail" :options="
          { 
            lazyLoad: 'sequential',
            start: 0,
            arrows: true,
            speed: 100,
            rewind: true, 
            fixedWidth: 100, 
            fixedHeight: 60, 
            gap: 0, 
            pagination: false,
            isNavigation: true,
            focus: 'center',
            breakpoints: {
              600: {
                fixedWidth : 60,
                fixedHeight: 44,
              },
            },
          }" 
          aria-label="Vue Splide Example" ref="thumbnail"
          @splide:active="updateCurrent">
          <SplideSlide v-for="image in filtered_images" v-bind:key="image">
            <img :data-splide-lazy="'https://aurorafinder.app/api/aurora_image/' + image.image_name" 
            @click="set_timestamp(image)"
            onerror="this.onerror=null;this.src='https://placehold.co/968x563/000000/FFF?text=No+Image/Video+Available';" 
            alt="No Image">
          </SplideSlide>
        </Splide>
        <div v-if="filtered_images.length === 0 && loaded" class="d-flex justify-center align-center ma-8"> 
          <v-row align="center">
            <v-col cols="12" class="d-flex align-center justify-center">
              <v-icon class="pr-6" icon="mdi-magnify-remove-outline" size="64" color="#1ac266"></v-icon>
              <div class="text-subtitle-2 text-grey">No images available. Check your filter setting.</div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>

    <v-row v-show="isVisible" class="pt-4 justify-center">
      <v-col>
        <v-card class="pa-4 d-flex align-center justify-center fill-height"  >
          <v-row>
            <v-col cols="12" class="pb-0">
              <span v-if="$vuetify.display.mobile && date_filter">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center">
                    <span>
                    <div class="text-subtitle-2 text-grey">Current Observation Period</div>
                    <div class="text-h8">{{convertTime(date_filter.first_date)}} - {{convertTime(date_filter.last_date)}}</div>
                    </span> 
                    <v-spacer></v-spacer>
                    <v-btn @click="observation_sheet = !observation_sheet" class="ml-2" icon="mdi-swap-horizontal" size="x-small" color="#1ac266"></v-btn>
                  </v-col>
                </v-row>
              </span>
              <v-select
                v-else
                label="Observation Period"
                :items="date_items"
                v-model="date_filter"
                @update:model-value="filterDate"
                return-object
                hide-details
                variant="solo-filled"
                :item-title="item => `${convertTime(item.first_date)} - ${convertTime(item.last_date)}`"
              >
              </v-select>
            </v-col>
            <v-col cols="12">
              <span v-if="$vuetify.display.mobile">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center">
                    <span>
                    <div class="text-subtitle-2 text-grey">Current Filter</div>
                    <div class="text-h8">{{ filter != 'All' ? (Object.values(filter_items).find(obj => obj.tiers === filter)).name : filter}}</div>
                    </span> 
                    <v-spacer></v-spacer>
                    <v-btn @click="tier_sheet = !tier_sheet" class="ml-2" icon="mdi-swap-horizontal" size="x-small" color="#1ac266"></v-btn>
                  </v-col>
                </v-row>
              </span>
              <v-select
                v-else
                label="Only Show"
                :items="filter_items"
                v-model="filter"
                @update:model-value="filterTier"
                item-title="name"
                item-value="tiers"
                hide-details
                variant="solo-filled"
              ></v-select>
            </v-col>
            <v-col cols="12" class="d-flex justify-center align-center pt-0">
              <NotificationPage />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col v-if="!$vuetify.display.mobile">
        <v-card class="pa-4 d-flex align-center justify-center fill-height">
          <v-card-text v-if="filtered_images.length > 0">
            <!-- <p>ID: {{ filtered_images[currentIndex].id }}</p>
            <p>Name: {{ filtered_images[currentIndex].image_name }}</p> -->
            <p>Date Received: {{ convertTime(filtered_images[currentIndex].timestamp) }}</p>
            <p>Tier: {{ convertTier(filtered_images[currentIndex].tier) }}</p>
            <!-- <p>Live: {{ currentLive }}</p> -->
            <!-- <p>Test Timestamp: {{ filtered_images[currentIndex].timestamp }}</p>
            <p>Test Live: {{ filtered_images[currentIndex].live }}</p>
            <p>Test Video ID: {{ filtered_images[currentIndex].video }}</p> -->
            <!-- <p>Height: {{ this.height_value }}</p>
            <p>Width: {{ this.width_value }}</p> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  <v-bottom-sheet v-model="observation_sheet" scrollable>
    <v-card>
      <v-card-title>Select Observation Period</v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 300px;" class="px-0">
        <v-list>
          <v-list-item
            v-for="item in date_items"
            :key="item.first_date"
            :title="convertTime(item.first_date) + ' - ' + convertTime(item.last_date)"
            @click="date_filter = item; filterDate(); observation_sheet = false"
          ></v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>

  <v-bottom-sheet v-model="tier_sheet" scrollable>
    <v-card>
      <v-card-title>Select Viewable Tiers</v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 300px;" class="px-0">
        <v-list>
          <v-list-item
            v-for="item in filter_items"
            :key="item.name"
            :title="item.name"
            @click="filter = item.tiers; filterTier(); tier_sheet = false"
          ></v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>

  </v-container>
</template>

<script>

import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import NotificationPage from './NotificationPage.vue';
import { useMainStore } from '@/store/store';
import { mapState } from 'pinia'

export default {
  setup() {
    const store = useMainStore()

    return { store }
  },
  name: 'ImageCarousel',

  components: {  
    Splide, 
    SplideSlide,
    VuePlyr,
    NotificationPage,
  },

  data: () => ({
    observation_sheet: false,
    tier_sheet: false,
    currentIndex: 0,
    selected_tier: null,
    all_images: [],
    filtered_images: [],
    filter_items: [
      { name: 'All', tiers: '-2-101234', },
      { name: 'Subdued and Higher', tiers: '1234' },
      { name: 'Engaging and Higher', tiers: '234' },
      { name: 'Vivid and Higher', tiers: '34', },
      { name: 'Brilliant', tiers: '4', },
    ],
    filter: 'All',
    date_filter: null,
    date_items: [],
    timestamp: 0,
    current_videoId: '',
    currentLive: false,
    currentDuration: null,
    initial_loaded: false,
    loaded: false,
    timer: null,
    src: "https://youtube.com/embed/",
    showImage: false,
    load_error: true,
    height_value: 0,
    width_value: 0,
  }),
  computed: {
    showVideo() {
      return this.filtered_images.length != 0 && this.filtered_images[this.currentIndex].video != ''
    },
    ...mapState(useMainStore, {
      userToken: store => store.token,
      user: store => store.user,
      isLoggedIn: store => store.isLoggedIn,
      isVisible: store => store.isVisible,
    }),
    isMobileSafari() {
      return /iP(ad|hone|od).*Version\/.*Safari/.test(navigator.userAgent)
    },
  },
  async mounted() {
    this.store.setVisibility(true)
    this.initial_loaded = false
    await this.retrieveGroups()
    // console.log(this.isLoggedIn)
    this.$refs.plyr.player.poster = '/loading.jpg'
    this.$refs.plyr.player.autoplay = false
    this.$refs.plyr.player.on('pause', () => {
      this.currentDuration = this.$refs.plyr.player.embed.getDuration()
      this.currentLive = this.$refs.plyr.player.embed.getVideoData().isLive
      // console.log(this.currentDuration)
    })
    this.$refs.plyr.player.on('statechange', (event) => {
      if (event.detail.code === 3 && !this.loaded) {
        // this.currentDuration = this.$refs.plyr.player.embed.getDuration()

        this.currentDuration = this.$refs.plyr.player.embed.getCurrentTime()
        this.currentLive = this.$refs.plyr.player.embed.getVideoData().isLive

        if (this.currentDuration > 0) {
          var seek = 0
          this.$refs.plyr.player.muted = true;
          this.$refs.plyr.player.volume = 0

          // Handles live video
          if (this.currentLive) {
            seek = (Math.abs(this.time_available - (this.timestamp.getTime() / 1000) + 5))
            if (seek <= 0) { seek = 1 }
            
            this.loaded = true
            this.$refs.plyr.player.play()
          }
        }
      }
    })
    this.$refs.main.splide.sync(this.$refs.thumbnail.splide)
    this.$refs.plyr.player.on('ready', () => {
      this.retrieveImages()
    })
    this.$refs.plyr.player.on('playing', () => {
      this.load_error = false
    })

    // Detect when entering fullscreen
    this.$refs.plyr.player.on('enterfullscreen', () => {
        this.hide_section = true
    })

    // Detect when exiting fullscreen
    this.$refs.plyr.player.on('exitfullscreen', () => {
        this.hide_section = false
        this.$refs.plyr.player.elements.container.style.width = this.width_value + 'px'
        this.$refs.plyr.player.elements.container.style.height = this.height_value + 'px'
    })

    // this.timer = setInterval(() => {
    //   this.retrieveImages()
    // }, 5000)
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    fullscreen() {
      this.store.setVisibility(false)
      this.original_style = this.$refs.plyr.player.elements.container.style

      this.$refs.plyr.player.elements.container.style.top = '0'
      this.$refs.plyr.player.elements.container.style.left = '0'
      this.$refs.plyr.player.elements.container.style.position = 'fixed'
      this.$refs.plyr.player.elements.container.style.zIndex = '9999'
      this.$refs.plyr.player.elements.container.style.width = '100vw'
      this.$refs.plyr.player.elements.container.style.height = '100vh'
      // console.log(this.$refs.plyr.player.elements.container.style)
    },
    exit_fullscreen() {
      this.store.setVisibility(true)
      this.$refs.plyr.player.elements.container.style = this.original_style
    },

    convertTier(tier) {
      switch(tier) {
          case "0":
              return "No Aurora"
          case "1":
              return "Subdued"
          case "2":
              return "Engaging"
          case "3":
              return "Vivid"
          case "4":
              return "Brilliant"
          case "-1":
              return "Cloud Obstructions"
          case "-2":
              return "Cloud Obstructions With Aurora"
          case "-3":
              return "Light Contamination"
      }
    },
    convertTime(date) {
      const shortDateTime = date.toLocaleString('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: '2-digit',
        hour: 'numeric',
        hour12: false,
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
      })
      return shortDateTime
    },

    async retrieveGroups() {
        const resp = await fetch('https://aurorafinder.app/api/video_groups/')
        const data = await resp.json()
        this.date_items = data
        this.date_items.forEach((item) => {
          item.first_date = new Date (item.first_date)
          item.first_date.setHours(item.first_date.getHours() - (item.first_date.getTimezoneOffset() / 60))

          item.last_date = new Date (item.last_date)
          item.last_date.setHours(item.last_date.getHours() - (item.last_date.getTimezoneOffset() / 60))
          
        })
        this.date_filter = this.date_items[this.date_items.length - 1]
    },

    async retrieveImages() {
        this.currentIndex = 0
        this.all_images = []
        // fetch('https://aurorafinder.app/api/images/'+ this.selected_tier +'/')
        const resp = await fetch('https://aurorafinder.app/api/images/' + this.date_filter.video_url + '/')
        const data = await resp.json()

        this.all_images = data
        // var timestamp = 0
        this.all_images.forEach((image) => {
          image.video = image.video_url
          image.timestamp = new Date (image.date_received)
          image.timestamp.setHours(image.timestamp.getHours() - (image.timestamp.getTimezoneOffset() / 60))
        })
        this.filtered_images = this.all_images
        this.initial_loaded = true
    },
    updateCurrent(image) {
      var seek = 0
      this.currentIndex = image.index
      if (this.showVideo) {
        this.timestamp = this.filtered_images[this.currentIndex].timestamp
        this.time_available = this.filtered_images[this.currentIndex].time_available
        this.loaded = false
        
        var new_videoId = this.filtered_images[this.currentIndex].video

        this.$refs.plyr.player.muted = true;
        this.$refs.plyr.player.volume = 0

        // Handles non-live video
        seek = (Math.abs(this.time_available - (this.timestamp.getTime() / 1000) + 15))
        if (seek <= 0) { seek = 1 }

        // Check if video is different, load if different
        if (this.current_videoId != new_videoId) {
          this.width_value = 0
          this.height_value = 0
          this.load_error = true
          this.showImage = false
          this.current_videoId = new_videoId
          this.$refs.plyr.player.embed.loadVideoById(this.filtered_images[this.currentIndex].video, seek)
          this.$refs.plyr.player.play()   
        }
        else {
          if (seek > this.$refs.plyr.player.duration) {
            this.showImage = true
          }
          else {
            this.showImage = false
            this.$refs.plyr.player.currentTime = seek
            this.$refs.plyr.player.play()
          }
        }
      }
      else {
        this.$refs.plyr.player.stop()
      }
      if (this.width_value == 0 && this.height_value == 0) {    
        this.width_value = this.$refs.plyr.player.elements.container.querySelector('.plyr__video-wrapper').offsetWidth
        this.height_value = this.$refs.plyr.player.elements.container.querySelector('.plyr__video-wrapper').offsetHeight
      }      
    },
    filterDate() {
      this.retrieveImages()
      this.filter = 'All'
      this.$refs.main.go(0)
    },
    filterTier() {
      
      // Store id of currently viewed image
      if (this.filtered_images.length > 0) {
        var current_id = this.filtered_images[this.currentIndex].id
      }
      
      // Filter images
      this.filtered_images = this.all_images.filter((image) => this.filter.includes(image.tier))

      // Find current image in filtered list
      var new_index = this.filtered_images.findIndex((image) => {
        return image.id == current_id
      })
      
      // If image is still in list, keep in current view
      if ((new_index != -1)) {
        this.currentIndex = new_index
        this.$refs.main.splide.go(new_index)
        this.$refs.thumbnail.splide.go(new_index)
      }
      else {
        this.currentIndex = 0
      }
      this.loaded = true
    },
    set_timestamp(image) {

      // If currently viewed image is clicked again, otherwise let splide:active event handle it
      if(this.timestamp == image.timestamp) {
        var seek = 0
        this.$refs.plyr.player.muted = true
        this.$refs.plyr.player.volume = 0

        if (this.currentLive) {
          seek = (Math.abs(image.time_available - (image.timestamp.getTime() / 1000) + 5))
          if (seek <= 0) { seek = 1 }
        }
        else {
          seek = (Math.abs(image.time_available - (image.timestamp.getTime() / 1000) + 15))
        }
        this.showImage = false
        this.$refs.plyr.player.currentTime = seek
        
      }
    },
  },
}
</script>

<style>

/* Uncomment for auto slide height */
/* .splide__list {
  align-items: flex-start;
}

.splide__slide:not(.is-active) {
  height: 0;
} */

.splide {
  max-width: 1000px;
  margin:auto;
  padding:auto;
}

.main .splide__slide img {
  max-width: 1000px;
  max-height: 563px;
  object-fit: cover;
  display: block;
  overflow: hidden;
}

.thumbnail .splide__slide img {
  width: 100%;
  height: 100%;
  border-color: coral;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.thumbnail .splide__slide {
  opacity: 0.6;
  border: none !important;
}

.thumbnail .splide__slide.is-active {
  opacity: 1;
  border: none !important;
  border-bottom: medium solid #1ac266 !important;
}

.plyr__video-embed iframe {
	top: -50%;
	height: 200%;
}

.plyr {
  height: 100%;
  width: 100%;
  max-width: 1000px;
  --plyr-color-main: #1ac266;
}

#wrapper{
  position: relative;
  justify-content: center;
  display: flex;
}
#wrapper video{
  position: relative;
  z-index: 100;
}
#wrapper h1{
  position: absolute;
  display: block;
  z-index: 150;
  left: 20px;
  top: 10px;
}
/* .plyr.plyr--loading::after {
  content: "Loading...";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #FFFFFF;
  font-size: 20px;
  z-index: 10;
} */

.v-card {
  border-radius: 8px !important; /* Adjust pixel value as needed */
}
</style>